<template>
    <div>
        <el-container class="container">
            <!--<el-header>-->
                <!--<div class="main-header-box">-->
                    <!--<div class="main-header-right-box">-->
                        <!--<img src="../../../../static/img/touxiangkaobei5.png" alt="">-->
                        <!--<img src="" alt="">-->
                    <!--</div>-->
                    <!--<div class="main-header-left-box">-->
                        <!--<div>{{userData.nikiName}}</div>-->
                        <!--<div style="margin-top: 15px;color: #ffffff;">角色：{{userData.roleList[0].roleName}}</div>-->
                        <!--<div style="color: #ffffff;">经验：{{userData.experience}}</div>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</el-header>-->
            <el-main style="overflow: -moz-scrollbars-none">
                <div class="container-main">
                    <div class="container-main-left">
                        <div class="shopImg">
                            <img src="../../../../static/img/nanjuese.png" alt="">
                        </div>
                        <div></div>
                    </div>
                    <div class="container-main-right">
                        <div class="container-main-right-header">
                            <div style="width: 50%;margin-left: 50%;margin: 10px auto">
                                <div>
                                    <el-button type="primary" @click="handle(0)">无人机</el-button>
                                </div>
                                <div>
                                    <el-button type="primary" @click="handle(1)">传感器</el-button>
                                </div>
                            </div>
                            <div style="width: 50%">
                            </div>
                        </div>
                        <div class="container-main-right-main">
                            <ul>
                                <li v-for="(item , index ) in list " @click="windowOpen(item,index)">
                                    <el-tooltip placement="bottom">
                                        <div slot="content" style="font-size: 16px">{{item.content}}</div>
                                        <div>
                                            <img :src="item.img_url">
                                        </div>
                                    </el-tooltip>
                                    <span>{{item.name}}</span>

                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
                <!-- TODO iframe嵌套div -->
                <div class="iframe-content" v-if="activeIndex  === 0">
                    <div @click="activeIndex = -1">
                        <i class="el-icon-error"></i>
                    </div>
                    <!-- iframe img 判断 -->
                    <iframe v-if="item.file_path.indexOf('jpg') == -1" :src="item.file_path" frameborder="0"></iframe>
                    <img v-if="item.file_path.indexOf('jpg') != -1" :src="item.file_path" alt="">
                    <div style="position: absolute;left: 10px;top:85px;width: 80%;font-size: 16px;font-weight: 700">
                        {{item.remark}}
                    </div>
                    <div style="position: absolute;left: 0;top: 570px;width: 400px;background: red" v-if="type == 3">
                        <img  style="height:200px !important;" src="../../../../static/img/jisuan.474de1c.png" alt="">
                    </div>
                    <div style="position: absolute;width: 200px;top:90vh;font-size: 16px;font-weight: 700;">
                        按住左键可拖动
                        可通过滚轮放大/缩小
                    </div>
                    <div style="display: flex;height: 50px;    top: 60vh;left: 20px;"  v-if="this.type === 2 && item.file_path.indexOf('jpg') == -1 ">
                            <el-button type="primary" plain @click="activeIndex  = 3">切换</el-button>
                    </div>
                </div>
                <div class="iframe-content" v-if="activeIndex  === 3">
                    <div @click="activeIndex = -1">
                        <i class="el-icon-error"></i>
                    </div>
                    <!-- iframe img 判断 -->
                    <iframe  :src="item.open_url" frameborder="0"></iframe>
                    <div style="position: absolute;left: 10px;top:85px;width: 400px;font-size: 16px;font-weight: 700">
                        {{item.remark}}
                    </div>
                    <div style="position: absolute;left: 0;top: 570px;width: 400px;background: red" v-if="type == 3">
                        <img  style="height:200px !important;" src="../../../../static/img/jisuan.474de1c.png" alt="">
                    </div>
                    <div style="position: absolute;width: 200px;top:90vh;font-size: 16px;font-weight: 700;">
                        按住左键可观看3d模型<br>
                        按住右键可拖动<br>
                        可通过滚轮放大/缩小
                    </div>
                    <div style="display: flex;height: 50px;    top: 60vh;left: 20px;" >
                        <el-button type="primary" plain @click="activeIndex = 0">切换</el-button>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>

    export default {
        name: 'shop',
        data() {
            return {
                item: '',
                activeIndex: -1,
                type: 2,
                userData: '',
                list: [
                    {
                        name: '灵眸 Osmo',
                        introduce: '这入的机会。他们鉴定结论是飞行数据不完整、数据无风、也不说几级风、试想除了室内在室外怎么可能绝对无风、只存在大小问题。只要一出问题商家就可以用这一条把责任全部推脱。我希望我已经上当了、别人就',
                    },
                    {
                        name: '索尼ILCE QX1',
                        introduce: '这入的机会。他们鉴定结论是飞行数据不完整、数据无风、也不说几级风、试想除了室内在室外怎么可能绝对无风、只存在大小问题。只要一出问题商家就可以用这一条把责任全部推脱。我希望我已经上当了、别人就',
                    }
                ],//传感器数组
            }
        },
        created() {
            //个人信息
            if (sessionStorage.userData) {
                this.userData = JSON.parse(sessionStorage.userData);
            } else {
                this.goMain('/login')
            }
            this.getData()
        },
        mounted() {

        },
        methods: {
            //ifream 标识
            windowOpen(item, index) {
                if (item.file_path.indexOf('jpg') == -1) {
                    this.item = item
                    window.open('#/webglTest?model3D='+item.dir_name);
                }else{
                    this.activeIndex = 0
                    this.item = item
                }

            },
            handle(index) {
                if (index === 0) {
                    this.type = 2
                    this.getData()
                } else if (index === 1) {
                    this.type = 3
                   this.getData()
                } else {
                    this.goMain('/main')
                }

            },
            //获取数据
            getData() {
                let params = {type: this.type}
                this.$axios.get(this.URL.uModel.selectUModelList, {params}).then(res => {
                    if (res.status === 200) {
                        console.log(res);
                        this.list = res.data
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .container {
        background: url("../../../../static/img/shopBackground.png");
        height: 100vh;
        .el-header {
            padding: 0;
            height: 120px !important;
        }
        .el-main {
        }
    }

    .main-header-box {
        position: absolute;
        right: 178px;
        display: flex;
        .main-header-left-box {
            margin-left: -240px;
            margin-top: 20px;
            font-size: 12px;
            :first-child {
                font-size: 18px;
                color: #ffffff;
                height: 30px;
            }
        }
        img {
            height: inherit;
        }
    }

    .container-main {
        display: flex;
        height: 100%;
        .container-main-left {
            width: 30%;
            display: flex;
            .shopImg {
                position: relative;
                width: 70%;
                img {
                    width: 70%;
                    position: absolute;
                    bottom: 5vh;
                }
            }
        }

        .container-main-right {
            background: url("../../../../static/img/di.png");
            border: 1px solid #3e577f;
            border-radius: 3px;
            width: 53.5%;
            margin-top: 10vh;
            height: 70vh;
            .container-main-right-header {
                :first-child {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    div {
                        margin-left: 5px;
                        width: 50%;
                    }
                }
            }
            .container-main-right-main {
                padding: 0 10px;
                ul {
                    display: flex;
                    flex-wrap: wrap;
                    width: 100%;
                    li {
                        font-size: 16px;
                        font-weight: 600;
                        margin-top: 5%;
                        margin-left: 30px;
                        text-align: center;
                        width: 20%;
                        div {
                            width: 100%;
                            height: 140px;
                            margin-bottom: 8px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
            }
        }
    }

    .iframe-content {
        z-index: 2;
        left: 0;
        top: 0;
        position: fixed;
        right: 0;
        bottom: 0;
        div {
            width: 30px;
            height: 30px;
            position: absolute;
            right: 20px;
            top: 20px;

        }
        iframe {
            width: 100%;
            height: 100vh;
        }
        img {
            width: 100%;
            height: 100vh;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/main/shop/main-shop.vue